import { render, staticRenderFns } from "./ZTag.vue?vue&type=template&id=7f449ff0&scoped=true&"
import script from "./ZTag.vue?vue&type=script&lang=js&"
export * from "./ZTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f449ff0",
  null
  
)

export default component.exports